export default {
    info: {
        method: 'GET',
        url: '/user/:uid/recent/{time}',
        name: '获取用户信息',
    },
    staffShops: {
        method: 'POST',
        url: '/manage-system/staff/staffShops',
        name: '获取当前登录职工所属门店',
    },
}